import { TEDCustomDateTimeParser } from './TEDCustomDateTimeParser';
import { TEDParseDateTimeMode } from '../FormatterTypes';

export class TEDParseDate extends TEDCustomDateTimeParser {
  public static getInstance(): TEDParseDate {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDParseDate;

  public mode() {
    return TEDParseDateTimeMode.pdmYMD;
  }
}
